import { trelloRestClient } from "@v2/shared/api/trello/restClient/trelloRestClient";
import { IBoardData, IOtherBoards, TCardState } from "../../../../@types";
import { createPrefetchStore } from "@v2/shared/lib/prefetch/createPrefetchStore";
import { TrelloIframeClientManager } from "@v2/shared/api/trello";

// all relevant fields, except 'checkItemStates'. If we would leave it, we could get (in rare cases) "Too many checklists" error.
// the items after 'url' (duereminder etc.) are not mentioned in the docs
const cardsFields =
  `badges,closed,dateLastActivity,desc,descData,due,email,` +
  `idBoard,idChecklists,idLabels,idList,idMembers,` +
  `idShort,idAttachmentCover,manualCoverAttachment,labels,name,pos,shortUrl,url,` +
  `dueReminder,idMembersVoted,shortLink,isTemplate,dueComplete,limits,cover`;

export const boardDataStoreQuery = createPrefetchStore<IBoardData>(
  async (state) => {
    return fetchBoardData(state);
  }
);

const fetchBoardData = async (state: TCardState = "open"): Promise<IBoardData> => {
  const trelloClient = await TrelloIframeClientManager.waitForClient();
  const client = await trelloRestClient();
  const { board: boardId, member: currentMemberId } = trelloClient.getContext();
  // note: with "open" we risk getting {"message":"Requested too many cards, please limit","error":"API_TOO_MANY_CARDS_REQUESTED"}
  // for some reason this is not the case for no state. Alternative might be "visible" (https://developer.atlassian.com/cloud/trello/rest/api-group-boards/#api-boards-id-cards-get)
  const resolvedState = state === "closed" ? state : "";
  const [cards, otherBoardsRaw, { labels, lists, members, customFields }] =
    await Promise.all([
      //Attempt at using /batch/ endpoint gave approx 20% longer times, hence sticking to Promise.all
      // ToDo: Check if you can get everything with one call to /board/{boardId}/.
      client("get", `/board/${boardId}/cards/${resolvedState}`, {
        fields: cardsFields,
        members: true,
        attachments: true,
        checklists: "all",
        stickers: true,
        customFields: true,
        customFieldItems: true,
      }),
      client("get", `/members/${currentMemberId}/boards`, {
        filter: "open",
        fileds: "all",
        organization: true,
        lists: "open",
      }),
      client("get", `/board/${boardId}`, {
        fields: "none",
        list_fields: "id,name,pos,idBoard",
        lists: "open",
        customFields: true,
        labels: "all",
        labels_limit: 0,
        label_fields: "all",
        members: "all",
        member_fields: "all",
      }),
    ]);

  const otherBoards = mapToBoardsWithOrganizations(otherBoardsRaw);
  const output: IBoardData = {
    currentMemberId,
    boardId,
    lists,
    cards,
    labels,
    members,
    otherBoards,
    customFields,
  };
  return output;
};

function mapToBoardsWithOrganizations(rawBoards): IOtherBoards[] {
  let output = [];
  output = rawBoards.map((b) => {
    return {
      id: b.id,
      name: b.name,
      isPersonal: !b.idOrganization && true,
      isGuest: b.idOrganization ? !b.organization : false,
      organization: b.idOrganization && {
        id: b.idOrganization,
        name: b.organization ? b.organization.displayName : undefined,
      },
      lists: b.lists,
    };
  });
  return output;
}
